import React, { useContext, useState } from 'react';
import {
  ChoseOptionContainer,
  ChoseOptionContent,
  ChoseOptionIcon,
  ChoseOptionParapraph,
  ChoseOptionFooter,
  ChoseOptionSelect,
  ChoseOptionRadioContainer,
  ChoseOptionRadioField,
  ChoseOptionRadioLabel
} from './styles';
import { BsShield, BsCheck } from 'react-icons/bs';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import colors from '../../../assets/styles/colors';
import { apSecureSteps, apSecureChoseOptions } from '../../../helpers/enum';
import { ApSecureContext } from '../../../store';
import { default as ApSecureTypes } from "../../../store/ApSecure/types";
import { useHistory, useLocation } from 'react-router-dom';
import { omitApSecure } from '../../../services/apSecure';
import Loader from '../../../components/Loader';
import AlertaValidacionIdentidad from '../../../components/AlertaValidacionIdentidad';

const ChoseOptionPage = ({ setActiveStep }) => {
  const location = useLocation();
  const history = useHistory();
  const { apSecure, setApSecure } = useContext(ApSecureContext);
  const [isLoading, setIsLoading] = useState(false);

  function setOptionSelect(item) {
    setApSecure({
      type: ApSecureTypes.SET_OPTION_SELECTED,
      option: item
    })
  }

  function verifyCheckboxModalidad(item) {
    return apSecure.option?.id === item.id;
  }

  function setNextStep() {
    setActiveStep(apSecureSteps.CHOSE_PLAN);
  }

  async function giveApSecure() {
    try {
      setIsLoading(true);
      const data = {
        idCredito: location.idCredit
      }
      
      await omitApSecure(data);

      setIsLoading(false);
      history.push({
        pathname: '/admin/references',
        idCredit: location.idCredit
      })
    } catch (error) {
      setIsLoading(false);
    }
  }

  function initializeStateComponent() {
    setOptionSelect(apSecureChoseOptions[0]);
  }


  useState(() => {
    initializeStateComponent();
  }, [])

  return (
    <ChoseOptionContainer>
      <ChoseOptionContent>
        <ChoseOptionIcon><BsShield color={colors.textPrimary} size={32} /></ChoseOptionIcon>
        <ChoseOptionParapraph>Debe ser del conocimiento del Cliente, que está adquiriendo una póliza de Accidentes Personales de manera voluntaria cuya Aseguradora es Pan American Life.</ChoseOptionParapraph>
        <ChoseOptionSelect>

          {apSecureChoseOptions.map(item => (
            <ChoseOptionRadioContainer key={item.id}>
              <ChoseOptionRadioField id="checkbox" checked={verifyCheckboxModalidad(item)} onClick={() => setOptionSelect(item)}>
                <BsCheck color={colors.white} id="check-icon" />
              </ChoseOptionRadioField>
              <ChoseOptionRadioLabel>{item.name}</ChoseOptionRadioLabel>
            </ChoseOptionRadioContainer>
          ))}

        </ChoseOptionSelect>
        <ChoseOptionFooter>
          <DefaultLargeButton type="button" id="button" onClick={() => giveApSecure()}>No tomar Seguro AP</DefaultLargeButton>
          <SecondaryLargeButton type="button" id="button" disabled={!apSecure.option.id} onClick={() => setNextStep()}>Tomar Seguro AP</SecondaryLargeButton>
        </ChoseOptionFooter>
      </ChoseOptionContent>
      {isLoading && <Loader />}
    </ChoseOptionContainer>
  )
}

export default ChoseOptionPage;
